(function() {
  'use strict';
  angular.module('ringbaPortal').directive('truncatedTextCopy', truncatedTextCopy);

  function truncatedTextCopy (

  ) {
    'ngInject';

    const directive = {
      restrict: 'E',
      scope: {
        copyText: '<',
        hideCopyButton: '<'
      },
      transclude: true,
      templateUrl: '/scripts/shared/directives/truncated-text-copy/truncated-text-copy.view.html'
    };

    return directive;
  }
})();
